export default {
  customer_page: {
    message: {
      created: "Created",
      updated: "Updated",
      deleted: "Deleted",
    },
  },
  no_result: "該当データは見つかりませんでした",
  error: "Internal error",
  un_selected: "指定なし",
  common: {
    message: {
      delete_confirm: "削除を実行します。この操作は取り消せません。",
      cancel_confirm:
        "変更内容を破棄して編集を終了します。この操作は取り消せません。",
      created: "作成しました",
      updated: "更新しました",
      deleted: "削除しました",
      cancel_button: "はい",
      cancel_delete_button: "キャンセル",
      not_change_password: "パスワードが変更されていません",
      errors: {
        image: "5MB以下の画像を選択してください",
      },
    },
    buttons: {
      cancel: "キャンセル",
      yes: "はい",
      no: "いいえ",
    },
    cancel_message: "{name}の編集内容を破棄します。この操作は取り消せません。",
    delivery_no_selected: "納入先を選択してください",
  },
  login: {
    required: {
      login_id_and_password: "ログインIDとパスワードを入力してください",
      login_id: "ログインIDを入力してください",
      password: "パスワードを入力してください",
    },
  },
  admin: {
    title_create: "社内利用者の新規作成",
    title_edit: "{name}の編集",
  },
  public: "公開",
  re_new: "更新",
  live_preview: {
    auction_overview: "オークション概要",
    period: "開催期間",
    end_time_varies: "鯉によって終了時刻は異なります",
    attention: `<p class="mb__text-lg mb__text-center">鯉のお預かりについて</p>
      <p class="mb__m-bottom-sm">出品鯉の説明欄に、
        <span class="EM">預かり代込、預かり可などの記載のない鯉は、原則、お預かりすることは出来ません。</span>
        <br />
        止むを得ない理由で長期のお預かりを希望される場合は、必ず、入札前にメール、又は、お電話にて御連絡下さい。
        <br />
        また、鯉を長期間お預かりする場合、
        <span class="EM">お預かり中の死亡保証は一切しておりません</span>
        ので、その点をご了承の上、御依頼下さい。
      </p>
      <p class="mb__asterisk">尚、メス保証にて販売致しました鯉が、オスであると判明した場合は、全額返金とさせて頂きます。</p>`,
    auction_carp_list: "オークション鯉一覧",
    all_producers: "生産者すべて",
    fish_farm: "玉浦養魚場",
    koi_farm: "面迫養鯉場",
    all_breeds: "品種すべて",
    read_and_white: "紅白",
    taisho_three_colors: "大正三色",
    all_genders: "性別すべて",
    male: "オス",
    female: "メス",
    unknown: "不明",
    price: "価格",
    the_following: "以下",
    show_only_the_koi_you_bid_on: "入札した鯉のみ表示",
    display: "表示",
    reset: "リセット",
    in_the_case: "件中",
    view: "件を表示",
    list: "リスト",
    thumbnail: "サムネイル",
    submitted_from_narita_fish_farm: "成田養魚園より出品",
    parent_carp: "親鯉",
    remaining: "残り",
    starting_price: "開始価格",
    current_price: "現在価格",
    photograph: "写真",
    movie: "動画",
    favorite: "お気に入り",
    bid: "入札",
    bid_content:
      "下記オークションの出品鯉に入札する場合は、入札額を入力し「入札」ボタンを押してください。",
    favorite_button: "お気に入り",
    breeder: "玉浦養魚場（成田養魚園より出品）",
    koi_data: "紅白 2歳 メス 54cm / 親鯉：レッドアイ",
    note_text: "2023年4月までの預かり料込（任意）",
    bid_history: "入札履歴",
    notice_bid_success: "様、あなたは現在",
    highest_bidder: "最高入札者",
    is: "です。",
    bid_amount: "入札額",
    please_enter_your_bid_amount: "様、入札額を入力してください。",
    nickname: "ニックネーム",
    rule_nickname: "半角英数5〜15文字（- _ ! ? # . 利用可）",
    error_price_below:
      "入札額が現在価格を下回っているため、入札できませんでした。",
    terms_of_service: "利用規約",
    agree_about: "について同意します",
    residing_overseas_notice:
      "海外在住のお客様のオークション参加は、成田養魚園から海外取引を許可された業者のみとなります",
    bid_amount_notice:
      "入札額の修正はお客様自身ではできません。入札額を間違えた場合は、",
    contact: "までご連絡ください。",
    button_cancel: "キャンセル",
    to_bid_on: "で入札する",
    final_bid_confirmation: "入札最終確認",
    bid_confirmation_notice:
      "下記オークションの出品鯉に入札します。この操作は取り消せません。",
    thank_you: "入札ありがとうございます",
    bid_success_notice: `入札が成功いたしました。<br />
      入札中のオークション一覧から現在価格のご確認が随時行えます。`,
    close_button: "閉じる",
    display_number_of_total:
      '<span class="mb__bold">{total}</span>件中<span class="mb__bold">{start}〜{end}</span>件を表示',
  },
  event_preview: {
    event_overview: "イベント概要",
    event_date: "開催日",
    pre_purchase_request_application: "事前購入希望申込",
    to: "{datetime}まで",
    list_event_carp: "イベント鯉一覧",
    all_producers: "すべての生産者",
    fish_farm: "玉浦養魚場",
    koi_farm: "面迫養鯉場",
    all_breeds: "すべての品種",
    read_and_white: "紅白",
    taisho_three_colors: "大正三色",
    all_genders: "性別すべて",
    male: "オス",
    female: "メス",
    unknown: "不明",
    female_now: "現在メス",
    the_following: "以下",
    koi_applied_purchase: "購入希望申込をした鯉のみ表示",
    display: "表示",
    reset: "リセット",
    in_the_case: "件中",
    view: "件を表示",
    list: "リスト",
    thumbnail: "サムネイル",
    printing: "印刷",
    parent_carp: "親鯉",
    photograph: "写真",
    movie: "動画",
    want_to_buy: "購入希望",
    applying_for_name: "名申込中",
    store_event: "店頭イベント",
    purchase_requests_notice:
      "下記店頭イベントの出品鯉に対して事前購入希望申込を行います。よろしいですか？",
    button_cancel: "キャンセル",
    button_apply: "申し込む",
    all_koi: "すべての鯉",
    purchase: "申込がある鯉",
    no_purchase: "申込がない鯉",
    price: "価格",
    display_number_of_total:
      '<span class="mb__bold">{total}</span>件中<span class="mb__bold">{start}〜{end}</span>件を表示',
    competitive_bidding: "入札鯉",
    event_not_found: "該当データは見つかりませんでした。",
  },
  show_preview: {
    page_title: "品評会入賞鯉",
    introduction: `錦鯉の品評会で、当園が取扱った上位入賞鯉をご紹介いたします。<br />
      全国品評会として有名な全日本総合錦鯉品評会以外にも若鯉大会・鱗友会など多数評価を頂いています。`,
    all_fairs: "すべての品評会",
    tokyo_games: "東京大会",
    wakai_conference: "若鯉大会",
    international_nishikigoi_show: "国際錦鯉品評会",
    friends_club: "鱗友会",
    tokai_area: "東海地区",
    asia_up: "アジアアップ",
    international_juvenile_fish_fair: "国際幼魚品評会",
    all_competitions: "すべての大会",
    all_producers: "すべての生産者",
    owner_name: "オーナー名",
    express: "表示",
    reset: "リセット",
    in_the_case: "件中",
    view: "件を表示",
    new_arrival_order: "新着順",
    old_order: "古い順",
    agency: "取次：",
    looks: "様",
    close: "閉じる",
    display_number_of_total:
      '<span class="mb__bold">{total}</span>件中<span class="mb__bold">{start}〜{end}</span>件を表示',
  },
  store_preview: {
    product_name: "商品名",
    price: "価格",
    quantity: "数量",
    add_to_cart: "カートに入れる",
    to_order_procedure: "ご注文手続きへ",
    add_shipping: "送料・返品について",
    notation: "特定商取引法に基づく表記について",
    product_list: "商品一覧",
    nishikigoi_feed: "錦鯉飼料",
    feed_for_larval_and_juvenile_fish: "仔魚・稚魚用飼料",
    title: "飼育資材ストア",
    back: "前のページに戻る",
    category: "カテゴリ",
    option_names: "オプション",
  },
  new_preview: {
    notice_list: "お知らせ一覧",
  },
  blog_preview: {
    blog_list: "ブログ一覧",
    creator_introduce: "この記事を書いた人のご紹介",
  },
  mailmagazine_management: {
    title: {
      send_test_confirm: "テスト送信の実行確認",
    },
    message: {
      send_test_confirm:
        "テスト送信はあらかじめ設定されたメールアドレス宛に送信します。<br>すべての言語が送信されるため、一つのメールアドレスに最大３通届きます。<br>テスト送信はすぐに行われます。",
    },
    button: {
      confirm: "送信する",
    },
  },
};
